import { Outlet } from "react-router-dom";

const PharmaPrimaryCareLayout = () => {
  return (
    <div className="pharma-primary-care__layout flex h-full w-full overflow-hidden">
      <div className="pharma-primary-care__outlet w-full flex-1">
        <Outlet />
      </div>
    </div>
  );
};

export default PharmaPrimaryCareLayout;
